import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma,
  minify1kh64osmcox7j as minify,
  access$formatDecodingException$tJsonExceptionsKt2yfifxvnjk03f as access$formatDecodingException$tJsonExceptionsKt,
  throwInvalidFloatingPointDecoded3ghwdo6vya1kj as throwInvalidFloatingPointDecoded,
} from './JsonExceptions.mjs';
import {
  getJsonNameIndex1fee1p51fy8fj as getJsonNameIndex,
  ignoreUnknownKeys1ot1okvsp9ttf as ignoreUnknownKeys,
  getJsonNameIndexOrThrow1a6a29i1xie0m as getJsonNameIndexOrThrow,
} from './JsonNamesMap.mjs';
import { ENUM_getInstance25239ht7oag6o as ENUM_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import { JsonElementMarker395jk2pil4789 as JsonElementMarker } from './JsonElementMarker.mjs';
import { JsonTreeReader1ycreu77eikqj as JsonTreeReader } from './JsonTreeReader.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import { classDiscriminator9fd3hvqsgfqq as classDiscriminator } from './Polymorphic.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  get_jsonPrimitivez17tyd5rw1ql as get_jsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
} from '../JsonElement.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { JsonDecodingExceptionoyag1psadwuw as JsonDecodingException } from '../JsonExceptions.mjs';
import { findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import {
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  MissingFieldException24tqif29emcmi as MissingFieldException,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { readPolymorphicJson7wfdzotvo8aj as readPolymorphicJson } from './TreeJsonDecoder.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { plus17rl43at52ays as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { missingFieldExceptionWithNewMessage2gqddjx5jxge9 as missingFieldExceptionWithNewMessage } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/JsonInternalDependencies.mjs';
import {
  switchMode35g725ikhjpwv as switchMode,
  WriteMode_MAP_getInstance2mu7mal5c4now as WriteMode_MAP_getInstance,
} from './WriteMode.mjs';
import {
  convertToByte2t4hntblnhq2k as convertToByte,
  fromInt2ii0rejb1w62w as fromInt,
  convertToShortn6n5n7ruahkm as convertToShort,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toDouble1kn912gjoizjp as toDouble } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_isUnsignedNumber3dxwaa3af8ncr as get_isUnsignedNumber } from './StreamingJsonEncoder.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from '../JsonDecoder.mjs';
import {
  toUInt21lx0mz8wkp7c as toUInt,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  toUShort7yqspfnhrot4 as toUShort,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import { _UInt___get_data__impl__f0vqqw30ojw38w2y6td as _UInt___get_data__impl__f0vqqw } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { _ULong___get_data__impl__fggpzbbo8lz7f8fnfy as _ULong___get_data__impl__fggpzb } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { _UByte___get_data__impl__jof9qr100nrznmlnqj as _UByte___get_data__impl__jof9qr } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { _UShort___get_data__impl__g02451raj6q6epxg1b as _UShort___get_data__impl__g0245 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DiscriminatorHolderClass;
function DiscriminatorHolder() {
  if (DiscriminatorHolderClass === VOID) {
    class $ {
      constructor(discriminatorToSkip) {
        this.discriminatorToSkip_1 = discriminatorToSkip;
      }
    }
    initMetadataForClass($, 'DiscriminatorHolder');
    DiscriminatorHolderClass = $;
  }
  return DiscriminatorHolderClass;
}
function trySkip($this, $receiver, unknownKey) {
  if ($receiver == null)
    return false;
  if ($receiver.discriminatorToSkip_1 === unknownKey) {
    $receiver.discriminatorToSkip_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.decodeElementIndex_bstkhp_k$(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.lexer_1.peekNextToken_1gqwr9_k$() === 4) {
    $this.lexer_1.fail$default_ly4hfp_k$('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.currentIndex_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.currentIndex_1 === -1)) {
      hasComma = $this.lexer_1.tryConsumeComma_9n2ve4_k$();
    }
  } else {
    $this.lexer_1.consumeNextToken_kteg6b_k$(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.lexer_1.canConsumeValue_oljqd7_k$()) {
    if (decodingKey) {
      if ($this.currentIndex_1 === -1) {
        var tmp0 = $this.lexer_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = !hasComma;
        var position = tmp0.currentPosition_1;
        if (!condition) {
          var tmp$ret$1 = 'Unexpected leading comma';
          tmp0.fail$default_ly4hfp_k$(tmp$ret$1, position);
        }
      } else {
        var tmp0_0 = $this.lexer_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition_0 = hasComma;
        var position_0 = tmp0_0.currentPosition_1;
        if (!condition_0) {
          var tmp$ret$3 = 'Expected comma after the key-value pair';
          tmp0_0.fail$default_ly4hfp_k$(tmp$ret$3, position_0);
        }
      }
    }
    $this.currentIndex_1 = $this.currentIndex_1 + 1 | 0;
    tmp = $this.currentIndex_1;
  } else {
    if (hasComma && !$this.json_1.configuration_1.allowTrailingComma_1) {
      invalidTrailingComma($this.lexer_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp0 = $this.json_1;
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.isElementOptional_heqq56_k$(index);
    var elementDescriptor = descriptor.getElementDescriptor_ncda77_k$(index);
    var tmp;
    if (isOptional && !elementDescriptor.get_isNullable_67sy7o_k$()) {
      tmp = $this.lexer_1.tryConsumeNull_2shltp_k$(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.get_kind_wop7ml_k$(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.get_isNullable_67sy7o_k$()) {
        tmp_0 = $this.lexer_1.tryConsumeNull_2shltp_k$(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      var tmp0_elvis_lhs = $this.lexer_1.peekString_d4c947_k$($this.configuration_1.isLenient_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.configuration_1.explicitNulls_1 && elementDescriptor.get_isNullable_67sy7o_k$();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        $this.lexer_1.consumeString_j3j2z7_k$();
        tmp$ret$0 = true;
        break $l$block_2;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.lexer_1.tryConsumeComma_9n2ve4_k$();
  while ($this.lexer_1.canConsumeValue_oljqd7_k$()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.lexer_1.consumeNextToken_kteg6b_k$(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.json_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.configuration_1.coerceInputValues_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.lexer_1.tryConsumeComma_9n2ve4_k$();
        tmp_0 = false;
      } else {
        var tmp0_safe_receiver = $this.elementMarker_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.mark_lz09aa_k$(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, descriptor, key);
    }
  }
  if (hasComma && !$this.json_1.configuration_1.allowTrailingComma_1) {
    invalidTrailingComma($this.lexer_1);
  }
  var tmp1_safe_receiver = $this.elementMarker_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.nextUnmarkedIndex_feexpp_k$();
  return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
}
function handleUnknown($this, descriptor, key) {
  if (ignoreUnknownKeys(descriptor, $this.json_1) || trySkip($this, $this.discriminatorHolder_1, key)) {
    $this.lexer_1.skipElement_eq7t4_k$($this.configuration_1.isLenient_1);
  } else {
    $this.lexer_1.path_1.popDescriptor_wfx7tc_k$();
    $this.lexer_1.failOnUnknownKey_g0pqrs_k$(key);
  }
  return $this.lexer_1.tryConsumeComma_9n2ve4_k$();
}
function decodeListIndex($this) {
  var hasComma = $this.lexer_1.tryConsumeComma_9n2ve4_k$();
  var tmp;
  if ($this.lexer_1.canConsumeValue_oljqd7_k$()) {
    if (!($this.currentIndex_1 === -1) && !hasComma) {
      $this.lexer_1.fail$default_ly4hfp_k$('Expected end of the array or comma');
    }
    $this.currentIndex_1 = $this.currentIndex_1 + 1 | 0;
    tmp = $this.currentIndex_1;
  } else {
    if (hasComma && !$this.json_1.configuration_1.allowTrailingComma_1) {
      invalidTrailingComma($this.lexer_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.configuration_1.isLenient_1) {
    tmp = $this.lexer_1.consumeStringLenientNotNull_m2rgts_k$();
  } else {
    tmp = $this.lexer_1.consumeKeyString_mfa3ws_k$();
  }
  return tmp;
}
var StreamingJsonDecoderClass;
function StreamingJsonDecoder() {
  if (StreamingJsonDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(json, mode, lexer, descriptor, discriminatorHolder) {
        super();
        this.json_1 = json;
        this.mode_1 = mode;
        this.lexer_1 = lexer;
        this.serializersModule_1 = this.json_1.get_serializersModule_piitvg_k$();
        this.currentIndex_1 = -1;
        this.discriminatorHolder_1 = discriminatorHolder;
        this.configuration_1 = this.json_1.configuration_1;
        this.elementMarker_1 = this.configuration_1.explicitNulls_1 ? null : new (JsonElementMarker())(descriptor);
      }
      get_json_woos35_k$() {
        return this.json_1;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeJsonElement_6lz9ye_k$() {
        return (new (JsonTreeReader())(this.json_1.configuration_1, this.lexer_1)).read_22xsm_k$();
      }
      decodeSerializableValue_xpnpad_k$(deserializer) {
        try {
          var tmp;
          if (!(deserializer instanceof AbstractPolymorphicSerializer())) {
            tmp = true;
          } else {
            tmp = this.json_1.configuration_1.useArrayPolymorphism_1;
          }
          if (tmp) {
            return deserializer.deserialize_sy6x50_k$(this);
          }
          var discriminator = classDiscriminator(deserializer.get_descriptor_wjt6a0_k$(), this.json_1);
          var tmp0_elvis_lhs = this.lexer_1.peekLeadingMatchingValue_y3am18_k$(discriminator, this.configuration_1.isLenient_1);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            var tmp2 = isInterface(deserializer, DeserializationStrategy()) ? deserializer : THROW_CCE();
            var tmp$ret$0;
            $l$block: {
              // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
              var tmp_1;
              if (!(tmp2 instanceof AbstractPolymorphicSerializer())) {
                tmp_1 = true;
              } else {
                tmp_1 = this.get_json_woos35_k$().configuration_1.useArrayPolymorphism_1;
              }
              if (tmp_1) {
                tmp$ret$0 = tmp2.deserialize_sy6x50_k$(this);
                break $l$block;
              }
              var discriminator_0 = classDiscriminator(tmp2.get_descriptor_wjt6a0_k$(), this.get_json_woos35_k$());
              var tmp2_0 = this.decodeJsonElement_6lz9ye_k$();
              // Inline function 'kotlinx.serialization.json.internal.cast' call
              var serialName = tmp2.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
              if (!(tmp2_0 instanceof JsonObject())) {
                var tmp2_1 = 'Expected ' + getKClass(JsonObject()).get_simpleName_r6f8py_k$() + ', but had ' + getKClassFromExpression(tmp2_0).get_simpleName_r6f8py_k$() + ' as the serialized body of ' + serialName;
                // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                var path = this.lexer_1.path_1.getPath_18su3p_k$();
                var tmp_2;
                if (this.get_json_woos35_k$().configuration_1.exceptionsWithDebugInfo_1) {
                  var tmp$ret$6 = toString(tmp2_0);
                  tmp_2 = toString(minify(tmp$ret$6));
                } else {
                  tmp_2 = null;
                }
                var inputValue = tmp_2;
                throw JsonDecodingException().new_kotlinx_serialization_json_JsonDecodingException_2f7233_k$(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, path, null, inputValue), tmp2_1, -1, path, inputValue, null);
              }
              var jsonTree = tmp2_0;
              var tmp0_safe_receiver = jsonTree.get_6bo4tg_k$(discriminator_0);
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
              var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
              var tmp_3;
              try {
                tmp_3 = findPolymorphicSerializer(tmp2, this, type);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof SerializationException()) {
                  var it = $p;
                  // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                  var shortMessage = ensureNotNull(it.message);
                  var tmp_5;
                  if (this.get_json_woos35_k$().configuration_1.exceptionsWithDebugInfo_1) {
                    var tmp$ret$10 = jsonTree.toString();
                    tmp_5 = toString(minify(tmp$ret$10));
                  } else {
                    tmp_5 = null;
                  }
                  var inputValue_0 = tmp_5;
                  throw JsonDecodingException().new_kotlinx_serialization_json_JsonDecodingException_2f7233_k$(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue_0), shortMessage, -1, null, inputValue_0, null);
                } else {
                  throw $p;
                }
              }
              var tmp_6 = tmp_3;
              var actualSerializer = isInterface(tmp_6, DeserializationStrategy()) ? tmp_6 : THROW_CCE();
              tmp$ret$0 = readPolymorphicJson(this.get_json_woos35_k$(), discriminator_0, jsonTree, actualSerializer);
            }
            return tmp$ret$0;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var type_0 = tmp_0;
          var tmp_7;
          try {
            tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
          } catch ($p_0) {
            var tmp_8;
            if ($p_0 instanceof SerializationException()) {
              var it_0 = $p_0;
              var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
              var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
              this.lexer_1.fail$default_ly4hfp_k$(message, VOID, hint);
            } else {
              throw $p_0;
            }
            tmp_7 = tmp_8;
          }
          var tmp_9 = tmp_7;
          var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy()) ? tmp_9 : THROW_CCE();
          this.discriminatorHolder_1 = new (DiscriminatorHolder())(discriminator);
          return actualSerializer_0.deserialize_sy6x50_k$(this);
        } catch ($p_1) {
          if ($p_1 instanceof MissingFieldException()) {
            var e = $p_1;
            if (contains(ensureNotNull(e.message), 'at path'))
              throw e;
            throw missingFieldExceptionWithNewMessage(e, plus(e.message, ' at path: ') + this.lexer_1.path_1.getPath_18su3p_k$());
          } else {
            throw $p_1;
          }
        }
      }
      beginStructure_yljocp_k$(descriptor) {
        var newMode = switchMode(this.json_1, descriptor);
        this.lexer_1.path_1.pushDescriptor_ymkfo8_k$(descriptor);
        this.lexer_1.consumeNextToken_kteg6b_k$(newMode.begin_1);
        checkLeadingComma(this);
        var tmp;
        switch (newMode.ordinal_1) {
          case 1:
          case 2:
          case 3:
            tmp = new (StreamingJsonDecoder())(this.json_1, newMode, this.lexer_1, descriptor, this.discriminatorHolder_1);
            break;
          default:
            var tmp_0;
            if (this.mode_1.equals(newMode) && this.json_1.configuration_1.explicitNulls_1) {
              tmp_0 = this;
            } else {
              tmp_0 = new (StreamingJsonDecoder())(this.json_1, newMode, this.lexer_1, descriptor, this.discriminatorHolder_1);
            }

            tmp = tmp_0;
            break;
        }
        return tmp;
      }
      endStructure_1xqz0n_k$(descriptor) {
        if (descriptor.get_elementsCount_288r0x_k$() === 0 && ignoreUnknownKeys(descriptor, this.json_1)) {
          skipLeftoverElements(this, descriptor);
        }
        if (this.lexer_1.tryConsumeComma_9n2ve4_k$() && !this.json_1.configuration_1.allowTrailingComma_1) {
          invalidTrailingComma(this.lexer_1, '');
        }
        this.lexer_1.consumeNextToken_kteg6b_k$(this.mode_1.end_1);
        this.lexer_1.path_1.popDescriptor_wfx7tc_k$();
      }
      decodeNotNullMark_us4ba1_k$() {
        var tmp;
        var tmp0_safe_receiver = this.elementMarker_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.isUnmarkedNull_1;
        if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
          tmp = !this.lexer_1.tryConsumeNull$default_t5tauc_k$();
        } else {
          tmp = false;
        }
        return tmp;
      }
      decodeNull_jzrmuj_k$() {
        return null;
      }
      decodeSerializableElement_uahnnv_k$(descriptor, index, deserializer, previousValue) {
        var isMapKey = this.mode_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
        if (isMapKey) {
          this.lexer_1.path_1.resetCurrentMapKey_1l0a77_k$();
        }
        var value = super.decodeSerializableElement_uahnnv_k$(descriptor, index, deserializer, previousValue);
        if (isMapKey) {
          this.lexer_1.path_1.updateCurrentMapKey_rv46l8_k$(value);
        }
        return value;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        var index;
        switch (this.mode_1.ordinal_1) {
          case 0:
            index = decodeObjectIndex(this, descriptor);
            break;
          case 2:
            index = decodeMapIndex(this);
            break;
          default:
            index = decodeListIndex(this);
            break;
        }
        if (!this.mode_1.equals(WriteMode_MAP_getInstance())) {
          this.lexer_1.path_1.updateDescriptorIndex_kw65aq_k$(index);
        }
        return index;
      }
      decodeBoolean_m0aca_k$() {
        return this.lexer_1.consumeBooleanLenient_iqeqb9_k$();
      }
      decodeByte_jzz7je_k$() {
        var value = this.lexer_1.consumeNumericLiteral_rdea66_k$();
        if (!(value === fromInt(convertToByte(value)))) {
          this.lexer_1.fail$default_ly4hfp_k$("Failed to parse byte for input '" + value.toString() + "'");
        }
        return convertToByte(value);
      }
      decodeShort_jjqk32_k$() {
        var value = this.lexer_1.consumeNumericLiteral_rdea66_k$();
        if (!(value === fromInt(convertToShort(value)))) {
          this.lexer_1.fail$default_ly4hfp_k$("Failed to parse short for input '" + value.toString() + "'");
        }
        return convertToShort(value);
      }
      decodeInt_8iq8f5_k$() {
        var value = this.lexer_1.consumeNumericLiteral_rdea66_k$();
        if (!(value === fromInt(convertToInt(value)))) {
          this.lexer_1.fail$default_ly4hfp_k$("Failed to parse int for input '" + value.toString() + "'");
        }
        return convertToInt(value);
      }
      decodeLong_jzt186_k$() {
        return this.lexer_1.consumeNumericLiteral_rdea66_k$();
      }
      decodeFloat_jcnrwu_k$() {
        var tmp0 = this.lexer_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.consumeStringLenient_9oypvu_k$();
          try {
            // Inline function 'kotlin.text.toFloat' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$0 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.fail$default_ly4hfp_k$("Failed to parse type '" + 'float' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.json_1.configuration_1.allowSpecialFloatingPointValues_1;
        if (specialFp || isFinite(result))
          return result;
        throwInvalidFloatingPointDecoded(this.lexer_1, result);
      }
      decodeDouble_ur8l0f_k$() {
        var tmp0 = this.lexer_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.consumeStringLenient_9oypvu_k$();
          try {
            tmp$ret$0 = toDouble(input);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.fail$default_ly4hfp_k$("Failed to parse type '" + 'double' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.json_1.configuration_1.allowSpecialFloatingPointValues_1;
        if (specialFp || isFinite_0(result))
          return result;
        throwInvalidFloatingPointDecoded(this.lexer_1, result);
      }
      decodeChar_dcmcfa_k$() {
        var string = this.lexer_1.consumeStringLenient_9oypvu_k$();
        if (!(string.length === 1)) {
          this.lexer_1.fail$default_ly4hfp_k$("Expected single char, but got '" + string + "'");
        }
        return charCodeAt(string, 0);
      }
      decodeString_x3hxsx_k$() {
        var tmp;
        if (this.configuration_1.isLenient_1) {
          tmp = this.lexer_1.consumeStringLenientNotNull_m2rgts_k$();
        } else {
          tmp = this.lexer_1.consumeString_j3j2z7_k$();
        }
        return tmp;
      }
      decodeInline_ux3vza_k$(descriptor) {
        return get_isUnsignedNumber(descriptor) ? new (JsonDecoderForUnsignedTypes())(this.lexer_1, this.json_1) : super.decodeInline_ux3vza_k$(descriptor);
      }
      decodeEnum_slg6lu_k$(enumDescriptor) {
        return getJsonNameIndexOrThrow(enumDescriptor, this.json_1, this.decodeString_x3hxsx_k$(), ' at path ' + this.lexer_1.path_1.getPath_18su3p_k$());
      }
    }
    initMetadataForClass($, 'StreamingJsonDecoder', VOID, VOID, [JsonDecoder()]);
    StreamingJsonDecoderClass = $;
  }
  return StreamingJsonDecoderClass;
}
var JsonDecoderForUnsignedTypesClass;
function JsonDecoderForUnsignedTypes() {
  if (JsonDecoderForUnsignedTypesClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(lexer, json) {
        super();
        this.lexer_1 = lexer;
        this.serializersModule_1 = json.get_serializersModule_piitvg_k$();
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      decodeInt_8iq8f5_k$() {
        var tmp0 = this.lexer_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.consumeStringLenient_9oypvu_k$();
          try {
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = toUInt(input);
            tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.fail$default_ly4hfp_k$("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      decodeLong_jzt186_k$() {
        var tmp0 = this.lexer_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.consumeStringLenient_9oypvu_k$();
          try {
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = toULong(input);
            tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.fail$default_ly4hfp_k$("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      decodeByte_jzz7je_k$() {
        var tmp0 = this.lexer_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.consumeStringLenient_9oypvu_k$();
          try {
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = toUByte(input);
            tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.fail$default_ly4hfp_k$("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      decodeShort_jjqk32_k$() {
        var tmp0 = this.lexer_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.parseString' call
          var input = tmp0.consumeStringLenient_9oypvu_k$();
          try {
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = toUShort(input);
            tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              tmp0.fail$default_ly4hfp_k$("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'JsonDecoderForUnsignedTypes');
    JsonDecoderForUnsignedTypesClass = $;
  }
  return JsonDecoderForUnsignedTypesClass;
}
//region block: exports
export {
  JsonDecoderForUnsignedTypes as JsonDecoderForUnsignedTypesaowwj2t4rf8t,
  StreamingJsonDecoder as StreamingJsonDecoderyo05rsghf9i6,
};
//endregion

//# sourceMappingURL=StreamingJsonDecoder.mjs.map
